export default {

  'upcoming-tutorials-articles-and-tutorial-requests': {
    type: 'normal',
    title: 'Upcoming Tutorials, Articles and Tutorial Requests',
    data: [
      { title: 'General', url: '/upcoming-tutorials-articles-and-tutorial-requests', },
      { title: 'Under Consideration', url: '/upcoming-tutorials-articles-and-tutorial-requests/under-consideration', },
    ],
  },

  'user-authentication-using-aws-cognito': {
    type: 'normal',
    title: 'User Authentication Using AWS Cognito',
    data: [
      { title: 'Getting Started', url: '/user-authentication-using-aws-cognito/getting-started', },
      { title: 'Setting Up The Frontend', url: '/user-authentication-using-aws-cognito/setting-up-the-frontend', },
    ],
  },



  'building-a-todo-application-using-graphql-and-aws-appsync': {
    type: 'sections',
    title: 'Building a Todo Application using GraphQL and AWS AppSync',
    data: [
      {
        title: 'Backend',
        data: [
          { title: 'Introduction', url: '/building-a-todo-application-using-graphql-and-aws-appsync', },
          { title: 'Designing Our Schema', url: '/building-a-todo-application-using-graphql-and-aws-appsync/designing-schema', },
          { title: 'Attaching Resolver', url: '/building-a-todo-application-using-graphql-and-aws-appsync/attaching-resolver', },
          { title: 'Attaching Update and Delete Resolvers', url: '/building-a-todo-application-using-graphql-and-aws-appsync/attaching-update-and-delete-resolvers', },
          { title: 'Creating Resources and Attaching Remaining Resolvers', url: '/building-a-todo-application-using-graphql-and-aws-appsync/creating-additional-resources-and-attaching-remaining-resolvers', },
          { title: 'Advanced Resolvers', url: '/building-a-todo-application-using-graphql-and-aws-appsync/advanced-resolvers', },
        ]
      },
      {
        title: 'Frontend',
        data: [
          { title: 'Getting Started With The Frontend', url: '/building-a-todo-application-using-graphql-and-aws-appsync/getting-started-with-the-frontend', },
          { title: 'The CRUD Operations', url: '/building-a-todo-application-using-graphql-and-aws-appsync/the-crud-operations', },
        ]
      },
    ]
  },






/*
  'hello-world': {
    type: 'normal',
    data: [
      { title: 'Hello', url: '/hello', },
      { title: 'World', url: '/world', },
    ],
  },

*/

}



// WEBPACK FOOTER //
// ./src/global/data/aside.js